import { render, staticRenderFns } from "./TabsItems.vue?vue&type=template&id=68e70a5c"
import script from "./TabsItems.vue?vue&type=script&lang=ts"
export * from "./TabsItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports